// 配列関連の共通サービス

/**
 * 配列をサイズ単位に分割する。
 * @param list
 * @param size
 * @returns
 */
export function chunk<T extends any[]>(list: T, size: number) {
  return list.reduce(
    (prev, _, index) =>
      index % size ? prev : [...prev, list.slice(index, index + size)],
    [] as T[][]
  );
}
